import { render, staticRenderFns } from "./UploadRange.vue?vue&type=template&id=64b3e7d0&scoped=true"
import script from "./UploadRange.vue?vue&type=script&lang=js"
export * from "./UploadRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3e7d0",
  null
  
)

export default component.exports